module.exports = __webpack_public_path__ + "img/team1.b9b7777d.jpg";